module.exports = __webpack_public_path__ + "static/media/AWAY-off.e024d384.svg";